export default "__VITE_ASSET__9a1164d5__"